import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Question } from '@app/models/help/question.model';

@Injectable({ providedIn: "root" })
export class QuestionService {

  private service = 'QuestionService';

  constructor(private http: HttpClient) {

  }

  public getList(index: number): any {
    return this.http.get(`api/${this.service}/list/${index}`);
  }

  public insert(question: Question) {
    return this.http.post(`api/${this.service}/insert`, question);
  }

  public update(question: Question) {
    return this.http.put(`api/${this.service}/update`, question);
  }

  public delete(id) {
    return this.http.delete(`api/${this.service}/delete/${id}`);
  }
}
